import {AfterViewInit, Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../../app.component';
import {EmitterService} from '../../service/EmitterService';
import {MatPaginator, MatSort} from '@angular/material';
import {Legends} from '../../model/Legends';
import {BlockService} from '../../service/BlockService';
import {SelectionModel} from '@angular/cdk/collections';
import {environment} from '../../../environments/environment';
import {MotifService} from '../../service/MotifService';
import {HttpClient} from '@angular/common/http';
import * as moment from 'moment';
import {AlertService} from '../../service/alert.service';
import {SessionService} from '../../service/SessionService';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-inteclia-table',
  templateUrl: './reclamation.component.html',
  styleUrls: ['./reclamation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ReclamationComponent implements OnInit, AfterViewInit {
  displayedColumns = ['', 'start', 'end', 'Motif', 'Comment'];
  public notAllowedMotifs = ['VISITEMED'];

  private columnDefinitions = [
    {def: 'select', show: false},
    {def: 'user', show: false},
    {def: 'status', show: true},
    {def: 'start', show: true},
    {def: 'end', show: true},
    {def: 'Motif', show: true},
    {def: 'Comment', show: true}
  ];
  private BreakOverflowColumnDefinitions = [
    {def: 'Date', show: true},
    {def: 'Duree', show: true},
    {def: 'Motif', show: true},
    {def: 'Comment', show: true}
  ];
  dataSource: any;
  dataSourceFilter: any;
  breakOverflows: any;
  selection = new SelectionModel<any[]>(true, []);
  disableFilter = false;
  listReclation = {};
  date    = null;
  user    = null;
  isMotif = true;
  _header = false;
  _key    = '';
  _width  = 'calc(100% - 220px)';
  _motifs = [];
  _typeMtf= [];
  blocks  = [];
  _html: any;
  _config: any;
  _loading = false;
  _loadingBar = false;
  _isEmpty = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input()
  public set Agents(data: any) {
  }
  @Input()
  public set ActiveSelectd(motif: any) {
    this.isMotif = motif;
  }
  @Input()
  public set header(header: any) {
    this._header = header;
  }

  @Input()
  public set key(header: any) {
    this._key = header;
  }

  @Input()
  public set columns(columns: any) {
    this.columnDefinitions = columns;
  }

  @Input()
  public set config(config: any) {
    this._config = config;
  }

  @Input()
  public set width(width: any) {
    const style   = environment.styles[this._key][width.replace('/', '')];
    if ( style !== undefined) {
      this._width = 'calc(100% - ' + style + ')';
      localStorage.setItem('sidenav', this._width);
    }
  }
  constructor(private app: AppComponent,
              private http: HttpClient,
              private emit: EmitterService,
              private blockService: BlockService,
              private motifService: MotifService,
              private alertService: AlertService,
              private route: ActivatedRoute,

              private sessionService: SessionService) {
    motifService.getMotif().subscribe( (item: any) => {
      this._motifs = item;
      this._motifs = this._motifs.filter(e => this.notAllowedMotifs.indexOf(e.code) == -1);
    });

  }

  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
  ngAfterViewInit() {
  }

  ngOnInit() {
    const item = this.blockService.currentUser;
    this._isEmpty = (typeof item=== 'undefined' && location.hash != '#/traitement');
    if ([null, undefined].indexOf(item) == -1) {
          if ( Object.keys(item).length > 0 ) {
          this.breakOverflows = item.breakOverflows;
          const el            = item.incoherences.filter(e => e.type === 'INCOHERENCE'
            && ['READY'].indexOf(e.reclamationStatus) > -1)
            .filter(e => ['SEUILMOINS', 'SEUILPLUS'].indexOf(e.motif.code) === -1)
          this.user           = item.user;
          const data          = el;
          this.date           = item.date;
          this.dataSource     = data;
          this.blocks         = item.incoherences;
      }
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.forEach(row => this.selection.select(row));
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  public CloseSideNav(){
    this.app.sidenavCalim.toggle()
  }
  public getLabelStatus(label: any) {
    return Legends[label].label;
  }

  public getMotifCode(obj: any, label) {
    return (Object.keys(obj).indexOf('motif') > -1 ? obj.motif[label] : '-');
  }

  public DateToGMT(date) {
    return this.blockService.DateToGMT(date);
  }
  getDisplayedColumns(columnDefinitions): string[] {
    const isShow = true;
    return columnDefinitions
      .filter(cd => !isShow || cd.show)
      .map(cd => cd.def);
  }
  setReclamation(row, text, flag) {
    if (typeof this.listReclation[flag] == 'undefined') this.listReclation[flag] = {};
    this.listReclation[flag][row.id] = text;
  }

  saveReclamation() {
    let Reclamation = {incoherences: [], breakOverflows: []};
    if (Object.keys(this.listReclation).length > 0 ) {
      this.dataSource.forEach((e, i) => {
        const inco = this.listReclation['inco'];
        if ( Object.keys(inco).map(e => parseInt(e)).indexOf(e.id) > -1 &&
        inco[e.id].length > 0) {
          e['commentReclamation'] = inco[e.id];
          Reclamation.incoherences.push(e);
        }
      });
      this.breakOverflows.forEach((e, i) => {
        const _break = this.listReclation['break'];
        if ( Object.keys(_break).map(e => parseInt(e)).indexOf(e.id) > -1 &&
        _break[e.id].length > 0) {
          // console.log(e)
          e['commentReclamation'] = _break[e.id];
          Reclamation.breakOverflows.push(e);
        }
      });
      // console.log(Reclamation);
      this.blockService.sendReclamation(Reclamation, () => {
        this.alertService.success('Opération avec succes', 0);
        setTimeout(() => {
          location.reload();
        }, 2000)
      })
    }
  }
  setMotif(el, v?: any) {
    this.dataSource.forEach((e, i) => {
      if (el.id == e.id) {
        this.dataSource[i]['old'] = this.dataSource[i].motif.code ;
        this.dataSource[i]['traitement'] = true;
        this.dataSource[i].motif.code = v.selected.value;
      }
    })
  }
  cancelIncoherence() {
    this.disableFilter = false;
    this._loadingBar = false;
    this.dataSource = [];
  }
  getIncoherence(motif, statut, start, end) {
    this.alertService.clear();
    // console.log(motif.selected !== undefined && statut.selected !== undefined)
    if (motif.selected !== undefined && statut.selected !== undefined
      || (start.value !== '' || end.value !== '')
    ) {
      this._loadingBar = true;
      this.dataSourceFilter = [];
      this.disableFilter = true;
      let data = {
        motif: motif.selected.value,
        isTreated: statut.selected.value,
        start: moment(start.value).format('YYYY-MM-DD'),
        end: moment(end.value).format('YYYY-MM-DD')
      };
      const query = JSON.stringify(data)
        .replace(/[\"\'\{\}]{1,}/g,'')
        .replace(/[\:]{1,}/g,'=')
        .replace(/\,/g, '&');
      // console.log(query )
      this.http.get(environment.api.blocktemps + '/block/incoherencesMass?' + query)
        .subscribe( item => {
          this.dataSource = item;
          this._loadingBar = false;
        }, err => {
          this.sessionService.redirectBadRequest(err);
        })
    } else {
      this.alertService.error('s\'il vous plait remplir tous les champs', 0);
    }
  }
  setAllMotif(v?: any) {
    this.dataSource.forEach((e, i) => {
      if (this.dataSource[i]['old'] === undefined) {
        this.dataSource[i]['old'] = this.dataSource[i].motif.code ;
      }
        this.dataSource[i].motif.code = v.selected.value;
    })
  }
  saveTraitement() {
    const d = this.dataSource
    if (d.length > 0 ) {
      this.blockService.putBlock(d, () => {
        this.alertService.success('Opération avec succes', 0);
      });
    }
  }

  save(action?) {
    switch (action) {
      case false: this.saveReclamation(); break;
      case true : this.saveTraitement(); break;
    }
  }

  setDuration(v) {
    return  Math.round(Math.floor(v / 60)) + 'min'
  }
}

const ELEMENT_DATA: any[] = [];
export interface Reclamation {
  id: string;
  comment: string;
}



// WEBPACK FOOTER //
// ./src/app/view/reclamation/reclamation.component.ts